'use client'
import { LogoutButton } from "@/components/auth/logout-button"

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html>
            <body>
                <h2>Something went wrong!</h2>
                <button onClick={() => reset()}>Try again</button>
                <pre>{error.stack}</pre>
                <p>If this error persists, please contact support.</p>
                <LogoutButton/>
            </body>
        </html>
    )
}